<!-- About / Filters / Graph -->
<p-accordion [multiple]="true" [activeIndex]="[1,2]">
	<!-- About -->
	<p-accordionTab header="About">
		<div class="p-3">
			<h3 class="mt-0 mb-2">Max Pain by DTE</h3>
			<p class="m-0">
				This tool calculates the “max pain” strike for each upcoming expiration date and plots:
			</p>
			<ul class="mt-2">
				<li>DTE (Days to Expiration) on the X axis</li>
				<li>Max Pain Strike on the Y axis</li>
			</ul>
			<p class="mt-2">
				Use “Fetch &amp; Plot” to compute the latest curve. Snapshots are saved locally and you can view a 3D
				history surface.
			</p>
		</div>
	</p-accordionTab>

	<!-- Filters -->
	<p-accordionTab header="Filters">
		<p-toolbar class="filters-toolbar">
			<div class="filters-container p-fluid">
				<form [formGroup]="optionChainForm" (ngSubmit)="submitForm()">
					<div class="grid">
						<div class="col-12 md:col-4">
							<div class="p-field">
								<label for="symbol">Symbol</label>
								<input id="symbol" type="text" pInputText formControlName="symbol"/>
							</div>
						</div>
					</div>

					<div class="p-toolbar-group-start">
						<button pButton type="submit" class="p-button-success" icon="pi pi-chart-line"
								label="Fetch & Plot"></button>
						<button pButton type="button" class="p-button-info" icon="pi pi-history" label="Plot 3D History"
								(click)="plotHistory3D()"></button>
					</div>
					<div class="p-toolbar-group-end">
						<button pButton type="button" class="p-button-secondary" icon="pi pi-refresh" label="Reset"
								(click)="resetForm()"></button>
						<button pButton type="button" class="p-button-danger" icon="pi pi-trash" label="Clear History"
								(click)="clearHistory()"></button>
					</div>
				</form>
			</div>
		</p-toolbar>
	</p-accordionTab>

	<!-- Graph -->
	<p-accordionTab header="Graph">
		<div class="container">
			<plotly-plot
				*ngIf="graphData && graphLayout"
				[data]="graphData"
				[layout]="graphLayout"
				[ngStyle]="{ width: '100%', height: '100%', display: 'block' }"
			></plotly-plot>
		</div>
	</p-accordionTab>
</p-accordion>


